// AdminWallets Component - Wallets overview
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Wallet } from 'lucide-react';
import { formatCAD } from '../../utils/currency';
import { useAdmin } from './AdminContext';

export default function AdminWallets({ users: propUsers, onUserSelect }) {
  const adminContext = useAdmin();
  // Use props if provided, otherwise fallback to context
  const users = propUsers || adminContext?.users || [];
  const language = adminContext?.language || 'fr';

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-emerald-500 to-green-600 flex items-center justify-center shadow-lg">
            <Wallet className="h-5 w-5 text-white" />
          </div>
          {language === 'fr' ? 'Tous les Portefeuilles' : 'All Wallets'}
        </CardTitle>
        <CardDescription>
          {language === 'fr' 
            ? 'Liste de tous les portefeuilles utilisateurs avec leurs soldes' 
            : 'List of all user wallets with balances'}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {users.length === 0 ? (
            <div className="text-center py-8 text-muted-foreground">
              {language === 'fr' ? 'Aucun portefeuille pour le moment' : 'No wallets yet'}
            </div>
          ) : (
            users.map((user) => (
              <div 
                key={user.user_id} 
                className="flex items-center justify-between p-4 rounded-xl border border-border hover:bg-muted/50 cursor-pointer transition-colors" 
                onClick={() => onUserSelect && onUserSelect(user.user_id)}
              >
                <div className="flex items-center gap-3">
                  <div className="h-10 w-10 rounded-full bg-emerald-100 dark:bg-emerald-900/30 flex items-center justify-center">
                    <Wallet className="h-5 w-5 text-emerald-600" />
                  </div>
                  <div>
                    <p className="font-medium">{user.name}</p>
                    <p className="text-sm text-muted-foreground">{user.email}</p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="font-bold text-lg text-emerald-600">
                    {formatCAD(user.wallet_balance || 0)}
                  </p>
                  <p className="text-xs text-muted-foreground">CAD</p>
                </div>
              </div>
            ))
          )}
        </div>
      </CardContent>
    </Card>
  );
}
